const nextSortDir = (currentDir) => {
  const dirs = {
    asc: () => "desc",
    desc: () => null,
    null: () => "asc",
    "": () => "asc",
  };

  return (dirs[currentDir] || dirs.desc)();
};

export default nextSortDir;
